
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_1lrp0_197",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_1lrp0_198",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_1lrp0_199",
  "visible-content-group": "awsui_visible-content-group_tc96w_1lrp0_199",
  "visible-content-title": "awsui_visible-content-title_tc96w_1lrp0_204",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_1lrp0_214",
  "visible-content-option": "awsui_visible-content-option_tc96w_1lrp0_220",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_1lrp0_233",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_1lrp0_436",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_1lrp0_440",
  "content-display-option": "awsui_content-display-option_tc96w_1lrp0_436",
  "placeholder": "awsui_placeholder_tc96w_1lrp0_490",
  "sorting": "awsui_sorting_tc96w_1lrp0_490",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_1lrp0_517",
  "drag-overlay": "awsui_drag-overlay_tc96w_1lrp0_524",
  "content-display": "awsui_content-display_tc96w_1lrp0_436",
  "content-display-title": "awsui_content-display-title_tc96w_1lrp0_557",
  "content-display-description": "awsui_content-display-description_tc96w_1lrp0_566",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_1lrp0_574",
  "root": "awsui_root_tc96w_1lrp0_581",
  "modal-root": "awsui_modal-root_tc96w_1lrp0_582",
  "trigger-button": "awsui_trigger-button_tc96w_1lrp0_583",
  "cancel-button": "awsui_cancel-button_tc96w_1lrp0_584",
  "confirm-button": "awsui_confirm-button_tc96w_1lrp0_585",
  "custom": "awsui_custom_tc96w_1lrp0_586",
  "second-column-small": "awsui_second-column-small_tc96w_1lrp0_590",
  "wrap-lines": "awsui_wrap-lines_tc96w_1lrp0_594",
  "striped-rows": "awsui_striped-rows_tc96w_1lrp0_595",
  "content-density": "awsui_content-density_tc96w_1lrp0_596",
  "page-size": "awsui_page-size_tc96w_1lrp0_597",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_1lrp0_598",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_1lrp0_599",
  "sticky-columns": "awsui_sticky-columns_tc96w_1lrp0_600",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_1lrp0_601",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_1lrp0_602",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_1lrp0_603",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_1lrp0_604"
};
  